import SectionHeading from "./SectionHeading";
import { processSteps } from "@/mocks/home";

export default function RepairProcess() {
  return (
    <section id="process" className="relative w-full overflow-hidden bg-primary-950 py-20 md:py-28">
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(oklch(var(--accent-300)) 1px, transparent 1px), linear-gradient(90deg, oklch(var(--accent-300)) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      ></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          tone="dark"
          eyebrow="Repair Process"
          title="접수부터 출고까지"
          highlight="투명한 5단계"
          desc="모든 과정을 실시간으로 공유합니다. 어느 단계에서 무엇을 하는지, 비용은 얼마인지 명확하게 안내해 드립니다."
        />

        <div className="relative mt-16">
          {/* horizontal connector (desktop) */}
          <div className="absolute left-0 right-0 top-[34px] hidden h-px bg-background-50/15 md:block"></div>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-5 md:gap-5">
            {processSteps.map((step, index) => (
              <div
                key={step.step}
                className="reveal relative flex gap-5 md:flex-col md:items-center md:text-center"
                style={{ transitionDelay: `${index * 90}ms` }}
              >
                {/* mobile vertical connector */}
                {index < processSteps.length - 1 && (
                  <div className="absolute left-[26px] top-16 h-[calc(100%+1rem)] w-px bg-background-50/15 md:hidden"></div>
                )}

                <div className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-accent-400/40 bg-primary-950 text-accent-300 md:mb-6">
                  <i className={`${step.icon} text-2xl`}></i>
                  <span className="absolute -right-1.5 -top-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 font-label text-[11px] font-black text-primary-950">
                    {step.step}
                  </span>
                </div>

                <div>
                  <h3 className="font-heading text-lg font-black text-background-50">{step.title}</h3>
                  <p className="mt-2 font-body text-sm leading-relaxed text-background-300">
                    {step.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="reveal mt-16 flex flex-col items-center justify-between gap-6 rounded-lg border border-background-50/15 bg-background-50/5 p-6 backdrop-blur-sm md:flex-row md:p-8">
          <div className="flex items-center gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-shield-check-line text-2xl"></i>
            </span>
            <div>
              <p className="font-heading text-lg font-black text-background-50">
                수리 후 48시간 완충 테스트
              </p>
              <p className="mt-1 font-body text-sm text-background-300">
                출고 전 모든 기능을 검수하고 결과 리포트를 함께 제공합니다.
              </p>
            </div>
          </div>
          <a
            href="#inquiry"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3.5 font-label text-base font-bold text-primary-950 transition-colors hover:bg-background-200 md:w-auto"
          >
            <i className="ri-file-add-line text-lg"></i>
            수리 접수하기
          </a>
        </div>
      </div>
    </section>
  );
}